const TrancheActionEnum = Object.freeze({
    DELETE_TRANCHE: 'DELETE_TRANCHE'
});

export default TrancheActionEnum;
